import {DEFAULT_DB_NAME,DEFAULT_DB_VERSION} from './defaultConfig.js';
let topObj=null;
try{
    topObj=window;
}catch(err){
    //web worker  环境
    topObj=self;
}
export const canUseIndexedDB=!!(topObj.indexedDB||topObj.mozIndexedDB||topObj.webkitIndexedDB||topObj.msIndexedDB);
//获取数据库
export function getAppDB(dbName,version){
    return new Promise((resolve,reject)=>{
        let indexedDB=topObj.indexedDB||topObj.mozIndexedDB||topObj.webkitIndexedDB||topObj.msIndexedDB;
        if(indexedDB){
            const request = indexedDB.open(dbName||DEFAULT_DB_NAME, version||DEFAULT_DB_VERSION);
            request.onsuccess=event=>{
                // console.log('数据库打开成功');
                resolve(event.target.result);
            };
            request.onupgradeneeded=event=>{
                console.log('数据库创建或更新');
            };
            request.onerror=event=>{
                // console.log('数据库打开失败');
                reject(new Error('数据库打开失败'));
            };
        }else{
            reject(new Error('当前浏览器不支持indexedDB'));
        }
    });
}
//获取表格
export function getAppStore(storeName,auth='readwrite'){//readwrite,readonly
    return new Promise((resolve,reject)=>{
        getAppDB().then(db=>{
            try{
                const transaction=db.transaction([storeName],auth);
                const store=transaction.objectStore(storeName);
                resolve(store);
            }catch(cerr){
                reject(cerr);
            }
        }).catch(err=>{
            reject(err)
        });
    });
}
//获取事务
export function getAppTransaction(storeNames,auth='readwrite'){
    return new Promise((resolve,reject)=>{
        getAppDB().then(db=>{
            try{
                const transaction=db.transaction(storeNames,auth);
                resolve(transaction);
            }catch(cerr){
                reject(cerr);
            }
        }).catch(err=>{
            reject(err)
        });
    });
}
//根据主键获取表格数据
export function getStoreDataByKey(store,key){
    return new Promise((resolve,reject)=>{
        try{
            let res=store.get(key);
            res.onerror=event=>{
                reject(key+'获取失败');
            };
            res.onsuccess=event=>{
                resolve(event.target.result);
            };
        }catch(err){
            reject(err);
        }
    });
}
//打开索引游标
export function getDataByIndexCursor(store,indexName,iDBKeyRange){
    return new Promise((resolve,reject)=>{
        let list=[];
        try{
            const cursor=store.index(indexName).openCursor(iDBKeyRange);
            cursor.onsuccess=event=>{
                let result=event.target.result;
                if(result){
                    list.push(result.value);
                    result.continue();
                }else{
                    resolve(list);
                }
                
            }
            cursor.onerror=event=>{
                reject(event);
            }
        }catch(err){
            reject(err);
        }
    });
}